<template>
  <div class="writerBox clearfix">
    <chapterList
      :chapterList="chapterList"
      v-if="islist"
      :newChapter="newChapter"
      @isOpenVo="isOpenVo"
      @chapterId="chapterId"
      :isShowList="isShowList"
    ></chapterList>
    <noneHint
      v-if="!islist"
      :noneListhint="noneListhint"
      @elseUrl="elseUrl"
    ></noneHint>
    <authorWrite
      :mainInfo="mainInfo"
      :isDrag="true"
      v-if="islist"
      :newChapter="newChapter"
      @changeChs="changeChs"
      @checkSuccess="checkSuccess"
      @delChapter="delChapter"
      @successsave="successsave"
    ></authorWrite>
    <!-- 引入弹窗 -->
    <pop
      :isShowPop="isShowPop"
      :isShowPublish="isShowPublish"
      :mainInfo="mainInfo"
      :bookname="bookname"
      :isShowCreateVo="isShowCreateVo"
      @changeobj="changeobj"
      @publishChapter="publishChapter"
      @isSuVo="isSuVo"
    ></pop>

    <!-- 引入提示弹窗 -->
    <surePop :ApplyInfo="ApplyInfo" @passbind="passbind"></surePop>
    <surePop :ApplyInfo="deleteInfo" @passbind="deletebind"></surePop>
  </div>
</template>
<script>
import {
  getvolume,
  draftChapters,
  getEditCon,
  publishOldChapter,
  delChapter
} from "apiurl/author";
import { gettoll } from "utils/storage";
import { mapState } from "vuex";
export default {
  metaInfo: {
    title: "草稿箱-源石阅读"
  },
  data() {
    return {
      isShowPop: false, // 控制弹窗时候显示
      isShowCreateVo: false, // 控制添加卷的弹窗是否显示
      chapterList: [],
      mainInfo: {
        mainCount: 0, // 字数
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "", //作者的话,
        volumelist: [],
        typelist: [],
        chapterType: "1",
        rollvalue: "0",
        isSavebtn: true,
        isPubtn: true,
        isDelBtn: true
      },
      saveChapter: {
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "" //作者的话,
      },
      newChapter: null, // 最新章节
      saveId: null,
      isShowList: true,
      isShowPublish: false, //发布弹出
      islist: true, //是否有章节
      noneListhint: {
        msg: "没有章节~~",
        btnmsg: "新建章节",
        isbtn: true,
        istype: "book"
      }, // 空状态的情况
      chapterConList: {
        mainCon: "", // 正文
        chapterTitle: "", //章节标题
        authorCon: "" //作者的话,
      },
      ApplyInfo: {
        isShow: false,
        title: "温馨提示",
        content: "更改内容尚未保存~~",
        hint: "* 更改的内容将消失",
        sure: "切换",
        cancle: "取消"
      }, //弹窗
      deleteInfo: {
        isShow: false,
        title: "温馨提示",
        content: "确定要删除此章节~~",
        hint: "* 章节将永久删除",
        sure: "删除",
        cancle: "取消"
      } //弹窗
    };
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.params.id > 0) {
        // 获取分卷
        this.getVolist();
        //   获取章节列表
        this.getChapters();
        // 判断是否可选收费章节
        if (gettoll() === true) {
          this.mainInfo.typelist = [
            { value: "1", desc: "免费章节" },
            { value: "2", desc: "付费章节" },
            { value: "3", desc: "公告" }
          ];
        } else {
          this.mainInfo.typelist = [
            { value: "1", desc: "免费章节" },
            { value: "3", desc: "公告" }
          ];
        }
      } else {
        this.islist = false;
        this.noneListhint = {
          msg: "作品还没创建哦~~",
          btnmsg: "创建作品",
          isbtn: true,
          istype: "book"
        };
      }
    });
  },
  methods: {
    // 打开vo弹窗
    isOpenVo(value) {
      this.isShowPop = value;
      this.isShowCreateVo = value;
    },
    // 关闭vo弹窗
    changeobj(obj) {
      this.isShowPop = obj.isShowPop;
      this.isShowPop = obj.isShowCreateVo;
    },
    // 获取分卷
    async getVolist() {
      let res = await getvolume(this.$route.params.id);
      if (res.success) {
        this.mainInfo.volumelist = res.data;
        this.mainInfo.volumelist.unshift({ id: "0", name: "未分卷" });
      }
    },
    // 没有章节点击跳转
    elseUrl() {
      if (this.$route.params.id > 0) {
        this.$router.push(`/authorManage/newChapter/${this.$route.params.id}`);
      } else {
        this.$router.push(`/authorManage/bookSetting/${this.$route.params.id}`);
      }
    },
    /* 获取添加卷是否成功 */
    isSuVo(isSuc) {
      if (isSuc.data) {
        this.getVolist();
        this.isShowCreateVo = false;
        this.isShowPop = false;
      } else {
        this.$message.error(isSuc.message);
      }
    },
    // 获取章节目录
    getChapters() {
      draftChapters({ bookId: this.$route.params.id })
        .then(res => {
          if (res.success) {
            this.chapterList = res.data;
            if (this.chapterList.length > 0) {
              this.newChapter = res.data[0].id;
              this.chapterId(this.newChapter);
            } else {
              this.islist = false;
            }
          }
        })
        .catch(() => {});
    },
    // 获取章节内容
    chapterId(id) {
      this.saveId = id;
      if (
        this.saveChapter.chapterTitle == this.mainInfo.chapterTitle &&
        this.saveChapter.mainCon == this.mainInfo.mainCon &&
        this.saveChapter.authorCon == this.mainInfo.authorCon
      ) {
        this.newChapter = id;
        this.getChapterCon(id);
      } else {
        this.ApplyInfo.isShow = true;
      }
    },
    // 获取章节内容的接口
    async getChapterCon(id) {
      let res = await getEditCon({ chapterId: id });
      if (res.success) {
        this.mainInfo.rollvalue = res.data.volumeId;
        this.mainInfo.chapterType = res.data.type;
        this.mainInfo.chapterTitle = res.data.iname;
        this.mainInfo.mainCon = res.data.icontent;
        this.mainInfo.authorCon = res.data.iadditional;
        this.mainInfo.mainCount = res.data.words;
        // 备份
        this.saveChapter = {
          chapterTitle: res.data.iname,
          mainCon: res.data.icontent,
          authorCon: res.data.iadditional
        };
        if (res.data.type == 1) {
          this.mainInfo.chapterType = "3";
        } else {
          if (res.data.free) {
            this.mainInfo.chapterType = "1";
          } else {
            this.mainInfo.chapterType = "2";
          }
        }
      }
    },
    // 保存后更改备用值
    successsave() {
      this.saveChapter = {
        chapterTitle: this.mainInfo.chapterTitle,
        mainCon: this.mainInfo.mainCon,
        authorCon: this.mainInfo.authorCon
      };
    },
    //内容未保存仍要切换
    passbind(value) {
      if (value) {
        this.getChapterCon(this.saveId);
        this.newChapter = this.saveId;
      }
    },
    // 更新目录
    changeChs() {
      draftChapters({ bookId: this.$route.params.id })
        .then(res => {
          if (res.success) {
            this.chapterList = res.data;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {});
    },
    // 获取分卷的简介
    /*  async getVolumeId(id){
                                                                                       let res = await getVoCon({volumeId: id})
                                                                                       if(res.success) {
                                                                                         
                                                                                       }
                                                                                     } */
    // 验证成功，打开发布弹窗
    checkSuccess() {
      this.isShowPublish = true;
      this.isShowPop = true;
    },
    // 发布章节
    publishChapter(time) {
      var main = this.mainInfo;
      let data = {
        bookId: this.$route.params.id,
        additional: main.authorCon,
        content: main.mainCon,
        freeType: main.chapterType,
        name: main.chapterTitle,
        submitType: "publish",
        volumeId: main.rollvalue,
        chapterId: this.newChapter
      };
      if (time !== "") {
        data.time = time;
        data.submitType = "tpublish";
      }
      publishOldChapter(this.qs.stringify(data))
        .then(res => {
          if (res.success) {
            this.isShowPublish = false;
            this.isShowPop = false;
            this.$message({
              message: "发布成功，并保存至已发布章节",
              type: "success"
            });
            this.saveChapter = {
              chapterTitle: this.mainInfo.chapterTitle,
              mainCon: this.mainInfo.mainCon,
              authorCon: this.mainInfo.authorCon
            };
            this.getChapters();
          }
        })
        .catch(() => {});
    },
    // 删除章节提示
    delChapter() {
      this.deleteInfo.isShow = true;
    },
    // 删除章节
    deletebind(value) {
      if (value) {
        delChapter({ chapterId: this.newChapter })
          .then(res => {
            if (res.success) {
              this.$message({
                message: "已删除此章节",
                type: "success"
              });
              this.getChapters();
            }
          })
          .catch(() => {});
      }
    }
  },
  computed: mapState({
    bookname: state => state.author.bookName
  }),
  beforeRouteLeave(to, from, next) {
    let $this = this;
    if (
      $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
      $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
      $this.saveChapter.authorCon == $this.mainInfo.authorCon
    ) {
      next();
    } else {
      let a = window.confirm("离开页面更改的内容将丢失！");
      if (a) {
        next();
      } else {
        next(false);
      }
    }
  },
  mounted() {
    let $this = this;
    window.onbeforeunload = function(e) {
      e = e || window.event;
      // 兼容IE8和Firefox 4之前的版本
      if (
        $this.saveChapter.chapterTitle == $this.mainInfo.chapterTitle &&
        $this.saveChapter.mainCon == $this.mainInfo.mainCon &&
        $this.saveChapter.authorCon == $this.mainInfo.authorCon
      ) {
        //console.log("tag", "可刷新");
      } else {
        if (e) {
          e.returnValue = "关闭提示";
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return "关闭提示";
      }
    };
  },
  destroyed() {
    window.onbeforeunload = null;
  }
};
</script>
<style lang="stylus" scoped>
.writerBox
    width 100%
</style>
